import React from 'react';
import { useTranslation } from 'react-i18next';

import CommonButton from '../../../../../components/common-button/CommonButton';
import CommonModal from '../../../../../components/common-modal/CommonModal';
import CommonTooltipEllipses from '../../../../../components/common-tooltip-ellipses/CommonTooltipEllipses';
import { Input } from '../../../../../components/common-inputs';

import scss from './FontNamingModal.module.scss';

function FontNamingModal({ fonts, onRename, onSave, onCancel }) {
  const { t } = useTranslation('settings');
  const isValid = fonts.every((font) => font.label.trim());

  const handleSubmit = (event) => {
    event.preventDefault();
    if (isValid) {
      onSave();
    }
  };

  return (
    <CommonModal isOpen={fonts.length > 0} onClose={onCancel} wrapperClassName={scss.modal} isAnimated>
      <form className={scss.form} onSubmit={handleSubmit}>
        <div className={scss.header}>
          <h3 className={scss.title}>{t('mediaStudioFontNamingTitle')}</h3>
          <p className={scss.hint}>{t('mediaStudioFontNamingHint')}</p>
        </div>

        <ul className={scss.list}>
          {fonts.map((font) => (
            <li key={font.id} className={scss.row}>
              <span className={scss.glyphs} style={{ fontFamily: font.stack }} aria-hidden='true'>
                Aa
              </span>

              <div className={scss.field}>
                <CommonTooltipEllipses toolTipText={font.fileName} label={font.fileName} className={scss.file} />
                <Input
                  value={font.label}
                  size='sm'
                  isError={!font.label.trim()}
                  onChange={(label) => onRename(font.id, label)}
                />
              </div>
            </li>
          ))}
        </ul>

        <div className={scss.actions}>
          <CommonButton type='button' styleColor='secondary' maxWidth={120} onClick={onCancel}>
            {t('cancel')}
          </CommonButton>
          <CommonButton type='submit' styleColor='primary' maxWidth={120} disabled={!isValid}>
            {t('save')}
          </CommonButton>
        </div>
      </form>
    </CommonModal>
  );
}

export default FontNamingModal;
